<template>
  <a-modal
    :title="$t('form.pay.payOnline')"
    v-model="show"
    :destroyOnClose="true"
    :centered="true"
    :maskClosable="false"
    :footer="null"
    @cancel="handleCancel"
  >
    <div class="modal-content">
      <a-form-model
        ref="payForm"
        style="width: 100%"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        layout="horizontal"
        :model="payForm"
      >
        <a-form-model-item :label="$t('form.pay.payCount')" v-show="qrcode_url == ''">
          <a-radio-group name="radioStorageGroup" v-model="payForm.config_id">
            <a-radio
              v-for="(item, index) in storageFeeList"
              :key="index"
              :value="item.id"
            >
              <font>{{ item.name }}/</font
              ><font size="+1" color="red">{{$t('descriptions.moneySybol') +  item.amount }}</font>
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          v-show="qrcode_url == ''"
          :label="$t('form.pay.field.payType.label')"
          prop="payType"
        >
          <a-radio-group name="radioGroup" v-model="payForm.pay_type">
            <a-radio v-if="alipayEnabled == '1'" value="alipay">
              <img src="@/assets/img/alipay.png" />
            </a-radio>
            <a-radio v-if="wxpayEnabled == '1'" value="wxpay">
              <img src="@/assets/img/wxpay.png" />
            </a-radio>
            <a-radio v-if="ecpayEnabled == '1'" value="ecpay">
              <img src="@/assets/img/ecpay.png" />
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <div
          v-if="qrcode_url && payForm.pay_type == 'wxpay'"
          style="text-align: center"
        >
          <img :src="qrcode_url" />
          <div style="margin-top: 5px">
            {{$t('form.pay.payFinish')}}?<a @click="payComplete" href="javascript:void(0);"
              >{{$t('actionTitles.clickHere')}}</a
            >{{$t('actionTitles.refresh')}}
          </div>
        </div>
      </a-form-model>
      <div class="payForm" v-show="false" v-html="payHtml"></div>
    </div>
    <a-divider v-show="qrcode_url == ''" />
    <div class="modal-footer" v-if="affirmSub" v-show="qrcode_url == ''">
      <a-button type="primary" style="margin-right: 15px" @click="payFormSubmit" :loading="affirmSubLoading">{{$t('actionTitles.payConfirm')}}</a-button
      >
    </div>
  </a-modal>
</template>

<script>
import { payDilatationStorage,getSiteConfig  } from "@/api/index";
import { getByType } from "@/api/payConfig";

export default {
  props: {
    userId: {
      type: Number,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      payForm: {
        pay_type: "",
        config_id:"",
        type: 3,
        orderResultURL:""
      },
      qrcode_url: "",
      storageFeeList: [],
      wxpayEnabled:"0",
      alipayEnabled:"0",
      ecpayEnabled:"0",
      payType:"",
      payHtml:"",
      affirmSub:false,
      affirmSubLoading:false,
    };
  },
  computed: {
    show: {
      get: function () {
        this.getSiteConfig();
        return this.visible;
      },
      set: function () {
        if (this.visible == true) {
          this.getStorageFee();
        }
      },
    },
    pay_type(){
      return this.payForm.pay_type;
    },
    config_id(){
      return this.payForm.config_id;
    }
  },
  watch:{
    pay_type(val,oldVal){
      console.log("val:",val);
      this.handleConfirm();
    },
    config_id(val,oldVal){
      console.log("val:",val)
      this.handleConfirm();
    }
  },
  mounted() {
    this.getStorageFee();
    
  },
  methods: {
    getSiteConfig(){
      getSiteConfig().then(res=>{
        if(res.data){
          this.wxpayEnabled = res.data.wxpay.enabled;
          this.alipayEnabled = res.data.alipay.enabled;
          this.ecpayEnabled = res.data.ecpay.enabled;
          // this.setPayType();
        }
      })
    },
    getStorageFee() {
      this.payForm = {
        ...{
          pay_type: "",
          amount: 0,
          uid: this.userId,
          type: 3,
          config_id: 0
        },
      };
      this.getSiteConfig();
      this.qrcode_url = "";
      getByType({ type: 2 }).then((res) => {
        this.storageFeeList = res.data;
      });
    },
    // 取消
    handleCancel() {
      this.$emit("close");
    },
    payFormSubmit(){
      $(".payForm form").submit();
    },
    // 保存
    handleConfirm() {
      let _self = this;
      if(_self.payForm.config_id==undefined || _self.payForm.config_id==null || _self.payForm.config_id==""){
        _self.affirmSub = false;
        return;
      }
      if(_self.payForm.pay_type==undefined || _self.payForm.pay_type==null || _self.payForm.pay_type==""){
        _self.affirmSub = false;
        return;
      }
      _self.affirmSubLoading = true;
      _self.affirmSub = true;
      this.payForm.uid = this.userId;
      this.payForm.orderResultURL = window.location.href;
      payDilatationStorage(this.payForm)
        .then((res) => {
          if (_self.payForm.pay_type == "alipay") {
            _self.payHtml = res.data.msg;
            _self.$nextTick(function () {
              $("#alipaysubmit").attr("target","_blank");
            });
          } else if(_self.payForm.pay_type == "wxpay") {
            _self.qrcode_url = res.data.qrcode_url;
          }else{
            _self.payHtml = res.data.msg;
          }
          _self.affirmSubLoading = false;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 支付完成
    payComplete() {
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 100%;
  max-height: 800px;
  overflow: auto;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
}
.modal-footer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.footer-left {
  width: 50%;
}
.material-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 33%;
  margin-top: 10px;
}
.item-img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
}
.item-img img {
  width: 100%;
}
.item-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>